module.exports = __webpack_public_path__ + "img/doente.1d066877.png";